<div class="bg-white">
    <div class="" *ngIf="!userForm.editUser">
        <div class="row align-items-end pb-3" style="height: 90px;">
            <div class="col-1"></div>
            <div class="col-7">
                <span class="header-content">
                    Add New
                </span>
            </div>
        </div>
        <div class="row">
            <div class="col-1"></div>
            <div class="col-7 save-people-subcontent py-3">
                Peer type
            </div>
        </div>
        <div class="row">
            <div class="col-1"></div>
            <div class="col-7 my-2">
                <mat-icon class="select-usertype" [ngStyle]="{ 'margin-left': userForm.role==='Mentor'? '45px': '165px'}">check_circle</mat-icon>
                <mat-button-toggle-group [(ngModel)]="userForm.role" class="shadow-sm">
                    <mat-button-toggle value="Mentor" style="border-radius: 10px 0px 0px 10px" disableRipple>Mentor</mat-button-toggle>
                    <mat-button-toggle value="Supporter" style="border-radius: 0px 10px 10px 0px" disableRipple>Supporter</mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </div>
    </div>
    <div class="row h-120 align-items-end pb-2" *ngIf="userForm.editUser">
        <div class="col-1"></div>
        <div class="col-5">
            <div class="d-flex">
                <div>
                    <div class="header-content">
                        People
                    </div>
                    <div class="sub-content mt-2">
                        Here, you can edit information about the peer and the mentor
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mr-0 py-2" *ngIf="userForm.editUser">
        <div class="col-1"></div>
        <div class="col-7 d-flex align-items-center justify-content-between">
            <div class="d-flex cursor" (click)="location.back()">
                <mat-icon class="font-20">keyboard_arrow_left</mat-icon>
                <span class="cursor font-weight-light font-14">Back</span>
            </div>
        </div>

    </div>
    <div id="userform" [ngClass]="{'bg-grey': userForm.editUser}">
        <div class="pb-5" *ngIf="userForm.editUser"></div>
        <div class="pt-2" style="overflow: hidden auto;" [ngStyle]="{'max-height': userForm.editUser?'calc(100vh - 210px)': ' calc(100vh - 245px)'}">
            <div class="row mr-0">
                <div class="col-1"></div>
                <div class="col-7">
                    <div class="save-people-subcontent py-3" *ngIf="!userForm.editUser">
                        Personal Details
                    </div>
                    <div class="card border-0">
                        <div>
                            <mat-form-field appearance="outline" class="w-33 top-left-border">
                                <mat-label>First Name</mat-label>
                                <input matInput [(ngModel)]="userForm.firstName">
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="w-33">
                                <mat-label>Last Name</mat-label>
                                <input matInput [(ngModel)]="userForm.lastName">
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="w-33 top-right-border">
                                <mat-label>DOB</mat-label>
                                <input matInput [matDatepicker]="picker" placeholder="DD/MM/YY" [(ngModel)]="userForm.userDob" readonly (click)="picker.open()">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="">
                            <mat-form-field appearance="outline" class="w-50">
                                <mat-label>Gender</mat-label>
                                <input matInput [(ngModel)]="userForm.gender">
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="w-50">
                                <mat-label>Sexuality (Optional)</mat-label>
                                <input matInput [(ngModel)]="userForm.sexuality">
                            </mat-form-field>
                        </div>
                        <div class="">
                            <mat-form-field appearance="outline" class="w-50">
                                <mat-label>Email</mat-label>
                                <input matInput [(ngModel)]="userForm.email">
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="w-50">
                                <mat-label>City</mat-label>
                                <input matInput [(ngModel)]="userForm.city">
                            </mat-form-field>
                        </div>
                        <div class="p-4 label-color" style="border: 1px solid rgba(0, 0, 0, 0.125);">
                            <div class="ml-3">
                                <div class="mb-3">Language/ Select the language</div>
                                <mat-chip-list cdkDropList cdkDropListOrientation="horizontal">
                                    <mat-chip cdkDrag *ngFor="let lang of defaultLanguages" disableRipple class="default-chips shadow" (click)="language=lang;addLanguage()">
                                        {{lang}}
                                    </mat-chip>
                                </mat-chip-list>
                                <div class="input-group mb-3 mt-3" style="width: calc( 100% - 25%) !important;">


                                    <mat-form-field class="custom-autocomplete" appearance="outline" style="width: calc(100% - 85px);">
                                        <input type="text" placeholder="Type to add more languages" (keydown.enter)="addLanguage()" [(ngModel)]="language" matInput [formControl]="languageControl" [matAutocomplete]="languages">
                                        <mat-autocomplete #languages="matAutocomplete">
                                            <mat-option *ngFor="let option of languageOptions | async" [value]="option" (click)="addLanguage()" class="label-color">
                                                {{option}}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                    <div class="input-group-append" style="width: 85px;">
                                        <button class="btn d-flex justify-content-center w-100 h-100 font-14 align-items-center" style="background-color: var(--primary-btn-color);color: white;
                                    border-radius: 0px 10px 10px 0px" (click)="addLanguage()"><span>Add</span></button>
                                    </div>
                                </div>
                                <mat-chip-list cdkDropList cdkDropListOrientation="horizontal">
                                    <mat-chip cdkDrag *ngFor="let lang of userForm.languages;let i=index" disableRipple class="default-chips selected-chips shadow">
                                        {{lang}}
                                        <button matChipRemove style="color: var(--primary-btn-color);" (click)="removeLanguage(i)">
                                            <mat-icon>close</mat-icon>
                                          </button>
                                    </mat-chip>
                                </mat-chip-list>
                            </div>
                        </div>
                        <div class="p-4 label-color" style="border: 1px solid rgba(0, 0, 0, 0.125);">
                            <div class="ml-3">
                                <div class="mb-3">Interests (Optional)</div>
                                <div class="mb-3">You can choose upto 4 interests</div>
                                <div class="input-group mb-3 mt-3" style="width: calc( 100% - 25%) !important;">
                                    <mat-form-field class="custom-autocomplete" appearance="outline" style="width: calc(100% - 85px);">
                                        <input type="text" placeholder="Type to add more interests" matInput [formControl]="interestControl" (keydown.enter)="addInterest()" [(ngModel)]="interest" [matAutocomplete]="interests">
                                        <mat-autocomplete #interests="matAutocomplete">
                                            <mat-option *ngFor="let option of interestOptions | async" [value]="option" (click)="addInterest()" class="label-color">
                                                {{option}}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                    <div class="input-group-append" style="width: 85px;">
                                        <button class="btn d-flex justify-content-center w-100 h-100 align-items-center font-14" style="background-color: var(--primary-btn-color);color: white;
                                    border-radius: 0px 10px 10px 0px" (click)="addInterest()"><span>Add</span></button>
                                    </div>
                                </div>
                                <mat-chip-list cdkDropList cdkDropListOrientation="horizontal">
                                    <mat-chip cdkDrag *ngFor="let lang of userForm.interests;let i=index" disableRipple class="default-chips selected-chips shadow">
                                        {{lang}}
                                        <button matChipRemove style="color: var(--primary-btn-color);" (click)="removeInterest(i)">
                                            <mat-icon>close</mat-icon>
                                          </button>
                                    </mat-chip>
                                </mat-chip-list>
                            </div>
                        </div>
                        <div class="p-4 label-color" style="border: 1px solid rgba(0, 0, 0, 0.125);border-radius:0px 0px 7px 7px">
                            <div class="ml-3">
                                <div class="mb-2">About (Optional)</div>
                                <div class="d-flex">
                                    <div class="input-group" style="width: 98% !important;">
                                        <textarea class="form-control py-4 font-14" placeholder="Type to add" rows="4" [(ngModel)]="userForm.about"></textarea>
                                    </div>
                                    <div class="d-none justify-content-center align-items-center" style="color: var(--primary-btn-color);width: 15%">Add</div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-3" style="position: absolute;right: 60px;">
                    <div class="card shadow border-0" style="border-radius:10px;" *ngIf="userForm.editUser">
                        <div class="p-3 h-70" style="border-bottom: 1px solid rgba(0, 0, 0, 0.125);">
                            <div class="row m-0 font-12" style="color:#A6A6A6">Added as</div>
                            <div class="d-flex font-13">
                                <mat-radio-group [(ngModel)]="userForm.role">
                                    <mat-radio-button class="pr-3" value="Mentor">Mentor</mat-radio-button>
                                    <mat-radio-button value="Supporter">Supporter</mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div class="p-3 h-70">
                            <div class="row m-0 font-12" style="color:#A6A6A6">Member since</div>
                            <div class="d-flex font-13">
                                {{ userForm.createdAt }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-1"></div>
                <div class="col-7 d-flex justify-content-end align-items-center p-4">
                    <div class="text-center cursor primary-btn-txt" *ngIf="!userForm.editUser" style="width: 35%;" (click)="navToBack()">Cancel</div>
                    <button class="btn d-flex justify-content-center align-items-center ml-3 primary-bg text-white" style="width:65%;height: 50px" [disabled]="!isUserFormValid()" *ngIf="!userForm.editUser" (click)="saveUser()">Add User</button>
                    <button class="btn d-flex justify-content-center align-items-center ml-3 text-white primary-bg w-33" style="height: 50px" [disabled]="!isUserFormValid()" *ngIf="userForm.editUser" (click)="updateUser()">save</button>
                </div>
            </div>
        </div>
    </div>

</div>